export default __webpack_public_path__ + "static/media/ICON_Transactions.c1da0e4c.svg";